import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ParentAppRoutingModule } from './parent-app-routing.module';
import { ParentappLoginComponent } from './parentapp-login/parentapp-login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { ProgressReportPageComponent } from './progress-report-page/progress-report-page.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import{RegistrationUserComponent}from'./registration-user/registration-user.component'
// import{RegistrationUserComponent} from'./registration-user/registration-user.component';
import { EmployeeStudentProgressReportComponent } from './employee-student-progress-report/employee-student-progress-report.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { ParentappHeaderComponent } from './parentapp-header/parentapp-header.component';
import { ParentappFooterComponent } from './parentapp-footer/parentapp-footer.component';
import { ParentappStudentProgressReportComponent } from './parentapp-student-progress-report/parentapp-student-progress-report.component';
import { StudentProgressReportComponent } from './student-progress-report/student-progress-report.component';
import { ProgressRepotTableComponent } from './progress-repot-table/progress-repot-table.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { DialogProgressReportTableComponent } from './dialog-progress-report-table/dialog-progress-report-table.component';
import {MatIconModule} from '@angular/material/icon';


export const MY_DATE_FORMAT = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    ParentappLoginComponent,
    ProgressReportPageComponent,
    RegistrationUserComponent,
    EmployeeStudentProgressReportComponent,
    ParentappHeaderComponent,
    ParentappFooterComponent,
    ParentappStudentProgressReportComponent,
    StudentProgressReportComponent,
    ProgressRepotTableComponent,
    DialogProgressReportTableComponent,


  ],
  imports: [
    CommonModule,
    ParentAppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    AcademicFormModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatIconModule
    
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMAT }],

})
export class ParentAppModule { }
